module.exports = __webpack_public_path__ + "static/media/card_visa.13119489.png";